var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    rx: 90,
    fill: "#E85A58"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.0465 90.2357C97.0465 107.487 83.157 121.472 66.0227 121.472C48.8885 121.472 35 107.491 35 90.2357C35 72.9804 48.8896 59.0002 66.0227 59.0002C83.156 59.0002 97.0465 72.9846 97.0465 90.2357ZM131.08 90.2357C131.08 106.476 124.134 119.639 115.568 119.639C107.001 119.639 100.056 106.471 100.056 90.2357C100.056 74.0001 107.001 60.8322 115.568 60.8322C124.134 60.8322 131.08 74.0001 131.08 90.2357ZM145 90.2357C145 104.786 142.557 116.58 139.544 116.58C136.532 116.58 134.089 104.782 134.089 90.2357C134.089 75.6898 136.531 63.8913 139.546 63.8913C142.559 63.8913 145 75.6867 145 90.2357Z",
    fill: "#F7E7CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.3dc0a0d225e9995b069f46bf740be1c3.svg";
export { ForwardRef as ReactComponent };